import { Button, Typography, useMediaQuery, useTheme } from "@mui/material";
import Grid from '@mui/material/Grid2';
import { useMenu } from "../../../providers/MenuProvider";
import { TFunction } from "i18next";
import { CredentialContainer, CredentialMetadataRepresentation } from "../../../api/representations";
import { KeycloakLoginOptions } from "libs/keycloak-js/lib/keycloak";
import { passwordButtonStyles, PasswordSpan, signInCredRowButtonGridStyles, signInCredRowGridStyles, signInCredRowPasswordStyles, signInCredRowTitleGridStyles } from "../styles";
import { formatDate } from "../../../utils/formatDate";
import { Trans } from "react-i18next";
import CheckIcon from "../../../icons/Check";
import { StyledChip } from "../../../components/styles";
import { PASSWORD_PLACEHOLDER } from "../../../constants";

interface CredentialRowProps {
  t: TFunction;
  meta: CredentialMetadataRepresentation & { email: any };
  accountType: string;
  updateAction: string;
  container: CredentialContainer;
  login: (options?: KeycloakLoginOptions | undefined) => void;
}

export default function CredentialRow({ t, meta, accountType, updateAction, login }: CredentialRowProps) {
  const theme = useTheme();
  const isDownXl = useMediaQuery(theme.breakpoints.down('xl'));
  const { isOpen } = useMenu();

  return (
      <Grid
        container
        aria-label={t('password-display-name')}
        data-testid={t('password-display-name')}
        sx={signInCredRowGridStyles}
      >
        <Grid container spacing={{ xs: 1, lg: (isOpen && isDownXl) ? 0 : 15 }} alignItems="center" size={{ xs: 12, sm: 'grow' }}>
            <Grid container spacing={{ xs: 2 }} size={{ xs: 12, lg: (isOpen && isDownXl) ? 7 : 'auto' }} sx={{ marginRight: (isOpen && isDownXl) ? '30px' : '10px' }}>
                <Grid sx={signInCredRowTitleGridStyles}>
                    <Typography sx={{fontWeight: 600}} color="secondary.main">
                      {meta?.credential && t('password-display-name')}
                      {meta?.email && t('email')}
                    </Typography>
                </Grid>
                <Grid>
                  {meta?.credential && (<Trans i18nKey="credentialCreatedAt">
                    {{ date: formatDate(new Date(meta.credential.createdDate)) }}
                  </Trans>)}
                  {meta?.email && <Typography>{meta?.email.userEmail}</Typography>}
                </Grid>
            </Grid>
            {meta?.credential && (<Grid container sx={signInCredRowPasswordStyles} spacing={1.5} size={{ xs: 12, lg: 'auto' }}>
                <PasswordSpan dangerouslySetInnerHTML={{ __html: PASSWORD_PLACEHOLDER }} />
                <StyledChip icon={<CheckIcon />} size="small" label="Secure" color="success" variant="outlined" />
            </Grid>)}
        </Grid>
        {meta?.credential && (<Grid size={{ xs: 12, sm: 'auto' }} sx={signInCredRowButtonGridStyles}>
            {updateAction && accountType != "CORPORATE" && (<Button
              variant="contained"
              size="small"
              sx={passwordButtonStyles}
              onClick={() => {
                login({ action: "ACCOUNT_UPDATE_PASSWORD" });
              }}
              data-testrole="update"
            >
              {t("changePassword")}
            </Button>)}
        </Grid>)}
      </Grid>
  );
}
